import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Svg,
  Path,
  G,
} from "@react-pdf/renderer";
import Html from "react-pdf-html";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import Markdown from "../../Shared/Markdown";
import mapPdfVoteIcon from "./mapPdfVoteIcon";
import ReactDOMServer from "react-dom/server";
import { toTitleCase } from "shared/@utils/formatString";

import OpenSansLightItalic from "./pdfFonts/OpenSans-LightItalic.ttf";
import OpenSansItalic from "./pdfFonts/OpenSans-Italic-VariableFont_wdth,wght.ttf";
import OpenSans from "./pdfFonts/OpenSans-Light.ttf";
import OpenSansBold from "./pdfFonts/OpenSans-Medium.ttf";
import OpenSansBoldItalic from "./pdfFonts/OpenSans-MediumItalic.ttf";

import { convertTimeZoneDisplayText } from "ManagementTeam/utils/timezone";
import { getNameOfTwoDaysMeeting } from "ManagementTeam/utils/meetingDateParse";
import moment from "moment-timezone";

const PdfSvg = () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 28.173 36"
  >
    <G id="PDF_Icon_Small" transform="translate(-14.782 -5)">
      <Path
        id="Path_35752"
        data-name="Path 35752"
        d="M40.052,28.75c-.794-.755-1.577-1.6-2.282-2.357-.333-.359-.651-.7-.949-1.011L36.8,25.36a9.363,9.363,0,0,0,.741-2.579c.142-1.659-.076-2.73-.664-3.268a1.636,1.636,0,0,0-1.554-.33,1.894,1.894,0,0,0-1.255,1.236,5.858,5.858,0,0,0,1.077,5.133,35.727,35.727,0,0,1-2.312,4.26,11.552,11.552,0,0,0-4.083,2.015c-1.288,1.073-1.811,2.138-1.437,2.921a1.5,1.5,0,0,0,1.427.775,3.014,3.014,0,0,0,1.443-.411C31.4,34.43,33,32.163,33.85,30.85a26.2,26.2,0,0,1,4.4-.737c.4-.034.8-.059,1.183-.077a8.251,8.251,0,0,0,3.99,2.32,4.414,4.414,0,0,0,.7.056,2.5,2.5,0,0,0,2.107-.868,1.127,1.127,0,0,0-.015-1.313c-.649-.959-2.606-1.486-5.513-1.486-.209,0-.425,0-.649.006Zm-10.676,5.3a1.454,1.454,0,0,1-.634.205.323.323,0,0,1-.066-.006c-.03-.125.076-.669,1.107-1.529a7.933,7.933,0,0,1,1.822-1.1,9.817,9.817,0,0,1-2.229,2.427ZM35.47,20.808c.107-.281.241-.408.325-.432h0c.081.077.42.518.269,2.315a5.537,5.537,0,0,1-.267,1.181A4.305,4.305,0,0,1,35.47,20.808Zm2.636,8.049a29.022,29.022,0,0,0-3.317.467c.517-.882,1-1.776,1.4-2.6.138.148.28.3.425.457.483.519,1.025,1.1,1.588,1.673Zm6.828,2c.021.032.021.045.016.053a1.127,1.127,0,0,1-.83.238,2.749,2.749,0,0,1-.432-.035,5.148,5.148,0,0,1-2.167-1.1c2.3.094,3.226.567,3.412.841Z"
        transform="translate(-7.945 -7.889)"
        fill="#243746"
      />
      <Path
        id="Path_35753"
        data-name="Path 35753"
        d="M34.907,5H16.794a2.013,2.013,0,0,0-2.012,2.012V38.988A2.013,2.013,0,0,0,16.794,41H40.943a2.012,2.012,0,0,0,2.012-2.012V13.05Zm0,2.845,5.2,5.2h-5.2Zm6.038,31.142H16.794V7.012h16.1V13.05a2.012,2.012,0,0,0,2.012,2.012h6.038Z"
        transform="translate(0 0)"
        fill="#243746"
      />
      <Path
        id="Path_35754"
        data-name="Path 35754"
        d="M35.88,68.7a1.3,1.3,0,0,0-.527-.281,3.289,3.289,0,0,0-.848-.086H33.3a.732.732,0,0,0-.515.157.674.674,0,0,0-.172.509v3.576a.7.7,0,0,0,.153.482.559.559,0,0,0,.811,0,.7.7,0,0,0,.156-.488V71.349h.771a2.075,2.075,0,0,0,1.358-.387,1.412,1.412,0,0,0,.47-1.143,1.672,1.672,0,0,0-.114-.631,1.278,1.278,0,0,0-.339-.485ZM35.1,70.2a.551.551,0,0,1-.294.2,1.8,1.8,0,0,1-.529.066h-.543V69.221h.543c.489,0,.688.1.766.177a.61.61,0,0,1,.156.439.594.594,0,0,1-.1.36Z"
        transform="translate(-10.577 -36.935)"
        fill="#243746"
      />
      <Path
        id="Path_35755"
        data-name="Path 35755"
        d="M48.034,68.778a1.59,1.59,0,0,0-.657-.352,3.414,3.414,0,0,0-.842-.091H45.31a.579.579,0,0,0-.665.665v3.4a1.5,1.5,0,0,0,.042.39.445.445,0,0,0,.21.271.829.829,0,0,0,.432.091h1.225a3.74,3.74,0,0,0,.589-.042,1.922,1.922,0,0,0,.5-.149,1.7,1.7,0,0,0,.432-.284,2.033,2.033,0,0,0,.408-.517,2.352,2.352,0,0,0,.233-.647,3.835,3.835,0,0,0,.075-.782,2.443,2.443,0,0,0-.755-1.955Zm-.818,3.253a.651.651,0,0,1-.218.125,1.036,1.036,0,0,1-.253.058q-.129.013-.359.013h-.622V69.258h.53a2.438,2.438,0,0,1,.707.09.831.831,0,0,1,.46.4,1.944,1.944,0,0,1,.194.982,1.634,1.634,0,0,1-.44,1.306Z"
        transform="translate(-17.685 -36.935)"
        fill="#243746"
      />
      <Path
        id="Path_35756"
        data-name="Path 35756"
        d="M60.776,68.336H58.561a.871.871,0,0,0-.366.068.463.463,0,0,0-.232.231.857.857,0,0,0-.069.368v3.569a.7.7,0,0,0,.155.491.565.565,0,0,0,.81,0,.706.706,0,0,0,.155-.494V71.132H60.47a.562.562,0,0,0,.38-.117.452.452,0,0,0,0-.647.55.55,0,0,0-.382-.121H59.014V69.24h1.761a.564.564,0,0,0,.4-.124.46.46,0,0,0,0-.658.563.563,0,0,0-.392-.122Z"
        transform="translate(-25.599 -36.935)"
        fill="#243746"
      />
    </G>
  </Svg>
);

Font.register({
  family: "Open Sans",
  fonts: [
    {
      src: OpenSans,
    },
    {
      src: OpenSans,
      fontWeight: "light",
    },
    {
      src: OpenSansBold,
      fontWeight: "bold",
    },
    {
      src: OpenSansItalic,
      fontStyle: "italic",
    },
    {
      src: OpenSansBoldItalic,
      fontWeight: "bold",
      fontStyle: "italic",
    },
    {
      src: OpenSansLightItalic,
      fontWeight: "light",
      fontStyle: "italic",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    padding: "36px",
    fontFamily: "Open Sans",
    fontWeight: "light",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  headerText: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  date: {
    color: "#243746",
    fontSize: "17.5px",
    fontWeight: "bold",
  },
  locationHeader: {
    color: "#243746",
    fontSize: "14px",
    fontWeight: "bold",
  },
  title: {
    color: "#415364",
    marginTop: "9px",
    fontSize: "24px",
  },
  attorneyNotice: {
    color: "#999999",
    fontWeight: "bold",
    fontSize: "14px",
  },
  bold: {
    fontWeight: "bold",
  },
  light: {
    fontWeight: "light",
  },
  regular: {
    fontWeight: "normal",
  },
  agendaItem: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "row",
    minHeight: "24px",
    maxHeight: "100%",
    alignItems: "center",
    marginTop: "3px",
    marginBottom: "3px",
  },
  descriptionBox: {
    color: "#415364",
    display: "flex",
    flexDirection: "column",
    paddingLeft: "10px",
    whiteSpace: "pre-line",
    fontSize: "12px",
    width: "300px",
  },
  footer: {
    position: "absolute",
    fontSize: "8px",
    bottom: "-10px",
    width: "100%",
    display: "flex",
    maxHeight: "8px",
    textAlign: "start",
  },
  body: {
    width: "100%",
    flex: 1,
    position: "relative",
  },
  thumbContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "10px",
    textAlign: "center",
  },
  rightBox: {
    display: "flex",
    marginLeft: "110px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  pdfIcon: {
    width: "20px",
  },
});

const htmlStyles = {
  "*": {
    margin: 0,
  },
  body: {
    whiteSpace: "pre-line",
    margin: 0,
  },
  p: {
    margin: 0,
    padding: 0,
    marginBottom: "5px",
  },
  li: {
    margin: 0,
    padding: 0,
  },
  ul: {
    margin: 0,
    padding: 0,
    marginLeft: "-17px",
  },
  ol: {
    margin: 0,
    padding: 0,
    marginLeft: "-17px",
  },
  article: {
    marginBottom: "-5px",
  },
  ".highlight": {
    backgroundColor: "#ffff00",
  },
  sup: {
    verticalAlign: "super",
    fontSize: 9,
  },
  sub: {
    verticalAlign: "sub",
    fontSize: 9,
  },
  strong: {
    fontFamily: "Open Sans",
    fontWeight: "bold",
  },
  em: {
    fontFamily: "Open Sans",
    fontStyle: "italic",
  },
};

const todaysDate = dayjs().format("MMMM DD, YYYY");

export function AgendaPdf({
  currentMeetingDate = null,
  currentMeetingInfo,
  date,
  agendaItems,
  futureMeetings,
  futureMeetingsForEC,
  isArchived = false,
  archivedMeeting,
  meetingType,
}) {
  const _agendaItems = agendaItems;

  const location =
    currentMeetingInfo.inPerson && currentMeetingInfo.inPerson.location
      ? currentMeetingInfo.inPerson.location
      : null;
  const city =
    currentMeetingInfo.inPerson && currentMeetingInfo.inPerson.city
      ? currentMeetingInfo.inPerson.city
      : null;
  const state =
    currentMeetingInfo.inPerson && currentMeetingInfo.inPerson.state
      ? currentMeetingInfo.inPerson.state
      : null;

  dayjs.extend(utc);
  const time =
    currentMeetingInfo.dates !== null &&
    currentMeetingInfo.dates !== undefined &&
    currentMeetingInfo.dates.length > 0
      ? `${dayjs
          .utc(currentMeetingInfo.dates[0].startsOn)
          .format("h:mm a")}. ${convertTimeZoneDisplayText(
          currentMeetingInfo.dates[0].timeZone
        )}`
      : "N/A";

  function formatTimeFromDb(timeString, timeZone) {
    var split = timeString.split(":");
    var hour = parseInt(split[0].replace(/[^0-9]+/g, ""));
    var minutes = split[1].replace(/[^0-9]+/g, "");
    var timeZoneText = convertTimeZoneDisplayText(timeZone);
    var timeZoneString = timeZoneText.substring(
      timeZoneText.indexOf("("),
      timeZoneText.indexOf(")") + 1
    );

    var am = "a.m.";
    if (hour > 11) {
      am = "p.m.";
    }
    if (hour > 12) {
      hour -= 12;
    }

    if (hour === 0) {
      hour = 12;
    }

    if (minutes.length < 2) {
      minutes = "0" + minutes;
    }
    return `${hour}:${minutes} ${am} ${timeZoneString}`;
  }

  const _meetingType =
    meetingType === "MT"
      ? "Management Team Agenda"
      : "Executive Committee Agenda";
  const _futureMeetings =
    meetingType !== "MT" ? futureMeetingsForEC || [] : futureMeetings;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          {/* "Dec 31, 2022 & Jan 01, 2023".length === 27 */}
          <View style={date.length !== 27 && styles.headerText}>
            <Text style={[styles.date]}>{date} </Text>
            <Text style={[styles.attorneyNotice]}>
              | Confidential and Subject to Attorney Client Privilege
            </Text>
          </View>
          <View
            style={[
              { display: "flex", flexDirection: "column", marginTop: "3px" },
            ]}
          >
            <Text style={[styles.bold, styles.locationHeader]}>
              {!isArchived && location
                ? `${location}${city ? `, ${city}` : ""}${
                    state ? `, ${state}` : ""
                  }`
                : archivedMeeting && archivedMeeting.inPerson
                ? `${archivedMeeting.inPerson.location}${
                    archivedMeeting.inPerson.city
                      ? `, ${archivedMeeting.inPerson.city}`
                      : ""
                  }${
                    archivedMeeting.inPerson.state
                      ? `, ${archivedMeeting.inPerson.state}`
                      : ""
                  }`
                : "Zoom"}
            </Text>
            <Text style={[styles.bold, styles.locationHeader]}>
              {!isArchived && time
                ? time
                : archivedMeeting &&
                  archivedMeeting.dates &&
                  archivedMeeting.dates.length > 0 &&
                  archivedMeeting.dates[0].startsOn
                ? `${formatTimeFromDb(
                    new Date(archivedMeeting.dates[0].startsOn).getUTCHours() +
                      ":" +
                      new Date(
                        archivedMeeting.dates[0].startsOn
                      ).getUTCMinutes(),
                    archivedMeeting.dates[0].timeZone
                  )} `
                : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={[styles.title, styles.bold]}>
              {isArchived && "Archived "}
              {_meetingType}
            </Text>
          </View>
          {!isArchived && (
            <View
              style={[
                styles.row,
                {
                  fontSize: "11px",
                  justifyContent: "flex-start",
                  marginTop: "6px",
                  marginBottom: "6px",
                },
              ]}
            >
              <Text style={styles.bold}>
                Future Scheduled Management Team Meetings{" "}
              </Text>
              <Text style={styles.light}>
                (all meetings start at 10:00 a.m. [PT] unless noted)
              </Text>
            </View>
          )}
          <View
            style={[
              styles.row,
              {
                fontSize: "12px",
                flexDirection: "column",
                justifyContent: "flex-start",
                paddingBottom: "8px",
                borderBottom: "1px solid #415364",
              },
            ]}
          >
            {_futureMeetings.map((meeting, index) => {
              if (meeting.isCompleted) return null;

              if (
                dayjs(meeting.dates[0]).format("MMMM DD, YYYY") !== date &&
                new Date(dayjs(meeting.dates[0]).format("MMMM DD, YYYY")) >
                  new Date(
                    currentMeetingDate ? currentMeetingDate.dates[0] : date
                  )
              ) {
                let meetingLocation = "";

                if (meeting.deliveryType?.toLowerCase() == "decision") {
                  meetingLocation += "(Decision)";
                } else {
                  let locations = [];

                  if (meeting.isInPerson && meeting.location) {
                    locations.push(meeting.location);
                  }

                  if (meeting.isVirtual) {
                    locations.push("Zoom");
                  }

                  if (locations.length > 0) {
                    let strLocations = locations.join(" & ");

                    meetingLocation += ` (${strLocations})`;
                  }
                }

                if (meeting.ifNeeded) {
                  let meetingDateNeeded = dayjs(
                    meeting?.dates[1]
                      ? meeting.dates[1]
                      : moment(meeting?.dates[0]).add(1, "days")
                  );

                  let dateIfNeeded = `—${meetingDateNeeded.format(
                    "MMMM DD, YYYY"
                  )} if needed`;

                  meetingLocation += dateIfNeeded;
                }

                return (
                  <View
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      fontSize: "12px",
                    }}
                  >
                    <Text style={styles.bold}>
                      {meeting.dates.length === 2
                        ? `${getNameOfTwoDaysMeeting(
                            meeting.dates.map((date) =>
                              dayjs(date).format("MMMM DD, YYYY")
                            )
                          )}`
                        : meeting.dates.length === 1
                        ? dayjs(meeting?.dates[0]).format("MMMM DD, YYYY")
                        : "None"}{" "}
                    </Text>
                    <Text style={styles.light}>{meetingLocation}</Text>
                  </View>
                );
              } else return null;
            })}
          </View>
        </View>
        <View style={[styles.body, { marginTop: "9px" }]}>
          {_agendaItems
            .filter((i) => !i.isAttendanceAgenda && !i.isDraft)
            .map((item, index) => {
              let leftBoxColor;
              // eslint-disable-next-line default-case
              switch (item?.assignedType) {
                case "Diamond":
                  leftBoxColor = "#7F6A45";
                  break;
                case "WWG":
                  leftBoxColor = "#91B6BB";
                  break;
                case "Attorney":
                  leftBoxColor = "#243746";
                  break;
              }
              const element = <Markdown content={item?.description || ""} />;
              const html = ReactDOMServer.renderToStaticMarkup(element)
                //
                .replaceAll("<mark>", "<span class='highlight'>")
                .replaceAll("</mark>", "</span>")
                // highlight text transform
                .replace(
                  "<sub><span class='highlight'><em><strong>",
                  "<span><em><strong><sub class='highlight'>"
                )
                .replace(
                  "</strong></em></mark></sub>",
                  "</sub></strong></em></mark>"
                )
                .replace(
                  "<sub><span class='highlight'><strong>",
                  "<span><strong><sub class='highlight'>"
                )
                .replace("</strong></span></sub>", "</sub></strong></span>")
                .replace(
                  "<sub><span class='highlight'><em>",
                  "<span><em><sub class='highlight'>"
                )
                .replace("</em></span></sub>", "</sub></em></span>")
                .replace(
                  "<sub><span class='highlight'>",
                  "<span><sub class='highlight'>"
                )
                .replace("</span></sub>", "</sub></span>")

                // Sup
                .replace(
                  "<sup><span class='highlight'><em><strong>",
                  "<span><em><strong><sup class='highlight'>"
                )
                .replace(
                  "</strong></em></span></sup>",
                  "</sup></strong></em></span>"
                )
                .replace(
                  "<sup><span class='highlight'><strong>",
                  "<span><strong><sup class='highlight'>"
                )
                .replace("</strong></span></sup>", "</sup></strong></span>")
                .replace(
                  "<sup><span class='highlight'><em>",
                  "<span><em><sup class='highlight'>"
                )
                .replace("</em></span></sup>", "</sup></em></span>")
                .replace(
                  "<sup><span class='highlight'>",
                  "<span><sup class='highlight'>"
                )
                .replace("</span></sup>", "</sup></span>")

                // Handle subscript with style
                .replaceAll("<sub><em><strong>", "<em><strong><sub>")
                .replaceAll("</strong></em></sub>", "</sub></strong></em>")
                .replaceAll("<sub><em>", "<em><sub>")
                .replaceAll("</em></sub>", "</sub></em>")
                .replaceAll("<sub><strong>", "<strong><sub>")
                .replaceAll("</strong></sub>", "</sub></strong>")

                // Handle superscript with style
                .replaceAll("<sup><em><strong>", "<em><strong><sup>")
                .replaceAll("</strong></em></sup>", "</sup></strong></em>")
                .replaceAll("<sup><em>", "<em><sup>")
                .replaceAll("</em></sup>", "</sup></em>")
                .replaceAll("<sup><strong>", "<strong><sup>")
                .replaceAll("</strong></sup>", "</sup></strong>");

              return (
                <View key={index} style={styles.agendaItem} wrap={true}>
                  <View
                    style={{
                      backgroundColor: leftBoxColor,
                      height: "100%",
                      width: "16px",
                    }}
                  />
                  <View style={styles.descriptionBox}>
                    <Text style={styles.light}>
                      {toTitleCase(item.assignee)}
                    </Text>
                    <Text style={styles.bold}>{item.title}</Text>
                    {item?.description && (
                      <Html
                        style={[styles.light, { fontSize: "12px" }]}
                        stylesheet={htmlStyles}
                      >
                        {html}
                      </Html>
                    )}
                  </View>
                  <View style={styles.rightBox}>
                    <View style={styles.pdfIcon}>
                      {item?.pdfName && <PdfSvg />}
                    </View>
                    <View style={styles.thumbContainer}>
                      {item?.votingStatus &&
                        item?.hasChoices &&
                        mapPdfVoteIcon(item.votingStatus)}
                    </View>
                  </View>
                </View>
              );
            })}
          <View style={styles.footer} fixed>
            <Text>
              {`This document is confidential and subject to attorney client privilege. For IBO Use Only. | Revised ${todaysDate} | CR# Not Reviewed`}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
